import Reflux from 'reflux';
import ShowData from 'shared/data/Show';

const async = { asyncResult: true },
  GlobalElementSetFormActions = Reflux.createActions({
    updateField: {},
    submit: {},
    create: async,
    save: async,
    delete: async,
  });

GlobalElementSetFormActions.delete.listenAndPromise(
  ShowData.deleteGlobalElementContainer,
);
GlobalElementSetFormActions.create.listenAndPromise(
  ShowData.createGlobalElementContainer,
);
GlobalElementSetFormActions.save.listenAndPromise(ShowData.update);

export default GlobalElementSetFormActions;
